<div class="project-status-dialog">
  <div class="project-status-dialog-content">
    <usimweb-icon
      [icon]="'sentiment_very_satisfied'"
      [size]="160"
      class="project-status-dialog-icon"
      *ngIf="projectStatus == 'processing'"
    ></usimweb-icon>
    <usimweb-icon
      [icon]="'sentiment_dissatisfied'"
      [size]="160"
      class="project-status-dialog-icon-failed"
      *ngIf="projectStatus == 'failed' || projectStatus == 'version_failed'"
    ></usimweb-icon>
    <div class="container">
      <div class="arrow">
        <div class="outer"></div>
        <div class="inner"></div>
      </div>
      <div class="message-body">
        <p *ngIf="projectStatus == 'processing'">Cloning simulation... Your simulation will be cloned in no time.</p>
        <p *ngIf="projectStatus == 'failed'">
          Oh no. Something went wrong. There has been a problem with the simulation data. Please check whether there are
          gaps in the mesh of your file or request support.
        </p>
        <p *ngIf="projectStatus == 'version_failed'">
          Oh no. Something went wrong. There has been a problem with the simulation data. Please try to
          <span style="color: #21a0d2; cursor: pointer" (click)="refreshResults()">restart</span>
          the simulation or
          <span style="color: #21a0d2; cursor: pointer" (click)="requestSupportDialog()">Contact</span>
          the support team.
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="projectStatus == 'processing' || projectStatus == 'failed'" class="project-status-dialog-progress">
    <strong>Cloning...</strong>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        *ngIf="projectStatus == 'processing'"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%; background-color: #f49602"
      ></div>
      <div
        class="progress-bar progress-bar-striped progress-bar-animated bg-danger"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%"
        *ngIf="projectStatus == 'failed'"
      ></div>
    </div>
  </div>
  <div *ngIf="projectStatus == 'failed'">
    <div class="custom-dialog-actions">
      <usimweb-button
        color="red"
        text="Close"
        style="position: relative; top: 120px"
        (btnClick)="close()"
      ></usimweb-button>
    </div>
  </div>
</div>
